export const WIDGET = `
    id
    codeSnippet
    avatarImage
    backgroundImage
`
